//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          dialogVisible: false,
          width: "45%",
          title: "测试",
          dialogFooter: [{
            fnName: "dialogCancel",
            text: "取消",
            type: ""
          }, {
            fnName: "dialogConfirm",
            text: "确定",
            type: "danger"
          }]
        };
      }
    },
    isDisabled: {
      default: false
    }
  },
  data: function data() {
    return {
      disabledTrue: this.isDisabled
    };
  },
  methods: {
    confirmBtn: function confirmBtn(val) {
      this.$emit("beforeClose", val);
    }
  },
  watch: {
    isDisabled: function isDisabled(newVal, oldVal) {
      this.disabledTrue = newVal;
    }
  },
  created: function created() {
    if (!Object.prototype.hasOwnProperty.call(this.options, "dialogFooter")) {
      this.$set(this.options, "dialogFooter", [{
        fnName: "dialogCancel",
        text: "取消",
        type: ""
      }, {
        fnName: "dialogConfirm",
        text: "确定",
        type: "primary"
      }]);
    }
  }
};